export default __webpack_public_path__ + "static/media/chat.a39b5070.png";